import { useStore } from '@nanostores/solid'
import { createSignal, Show } from 'solid-js'
import {
  $chinaAndroidTrialEligibility,
  $debugAfterPaymentError,
  $debugSimulateInterrupted,
  $isReminderViewOpen,
  $isTrialEligible,
} from '~/store'

export function DevTools() {
  const [isOpen, setIsOpen] = createSignal(false)
  const isTrialEligible = useStore($isTrialEligible)
  const chinaAndroidTrialEligibility = useStore($chinaAndroidTrialEligibility)
  const isReminderViewOpen = useStore($isReminderViewOpen)
  const debugAfterPaymentError = useStore($debugAfterPaymentError)
  const debugSimulateInterrupted = useStore($debugSimulateInterrupted)
  const shouldShow = () =>
    (isTrialEligible() || chinaAndroidTrialEligibility() !== 'unavailable') &&
    !isReminderViewOpen()

  return (
    <Show when={shouldShow()}>
      {/*pointer event auto: prevent disabling pointer events from portaled
      dialog*/}
      <div class="pointer-events-auto fixed left-2 top-[calc(var(--safe-area-top)+8px)] z-[1000]">
        <Show
          when={isOpen()}
          fallback={
            <button
              onClick={() => setIsOpen(true)}
              class="rounded-full bg-black/80 px-3 py-1.5 text-xs font-medium text-white shadow-lg"
            >
              dev
            </button>
          }
        >
          <div class="flex flex-col gap-1 rounded-lg bg-black/80 p-2 text-xs text-white shadow-lg">
            <div class="mb-1 flex items-center justify-between gap-2">
              <span class="font-semibold">Dev Tools</span>
              <button
                onClick={() => setIsOpen(false)}
                class="text-white/60 hover:text-white"
              >
                ✕
              </button>
            </div>
            <label class="flex cursor-pointer items-center gap-2 pt-1">
              <input
                type="checkbox"
                checked={debugAfterPaymentError()}
                onChange={(e) =>
                  $debugAfterPaymentError.set(e.currentTarget.checked)
                }
                class="h-4 w-4 cursor-pointer"
              />
              <span class="select-none">Simulate AfterPaymentError</span>
            </label>

            <label class="flex cursor-pointer items-center gap-2 pt-1">
              <input
                type="checkbox"
                checked={debugSimulateInterrupted()}
                onChange={(e) =>
                  $debugSimulateInterrupted.set(e.currentTarget.checked)
                }
                class="h-4 w-4 cursor-pointer"
              />
              <span class="select-none">Simulate interrupted (abandon)</span>
            </label>
          </div>
        </Show>
      </div>
    </Show>
  )
}
